import { Colors } from "@/common/constants";
import { makeStyles } from "@fluentui/react-components";

export const useStyle = makeStyles({
	overflowAuto: {
		overflowY: "auto",
	},
	resumeButton: {
		cursor: "pointer",
	},
	buttonContainer: {
		flexShrink: 0,
		maxWidth: "100%",
		overflow: "hidden",
	},
	actionButton: {
		paddingLeft: "11px",
		paddingRight: "11px",
		backgroundColor: Colors.ButtonGreenBackground,
		"&:hover, &:hover:active": {
			backgroundColor: Colors.ButtonGreenBackground,
		},
	},
});
